module.exports = __webpack_public_path__ + "static/img/autumn_banner.2c8c98db.jpg";